import angular from 'angular';

import USERS_EVENTS from './constants/usersEvents.constant';
import usersContainer from './containers/users.container';
import UsersActivitiesContainer from './containers/usersActivities.container';
import usersBrandAdminModalContainer from './containers/usersBrandAdminModal.container';
import usersBrandsListContainer from './containers/usersBrandsList.container';
import usersEditModalContainer from './containers/usersEditModal.container';
import usersListContainer from './containers/usersList.container';
import usersPermissionsModalContainer from './containers/usersPermissionsModal.container';
import usersRevokeModalContainer from './containers/usersRevokeModal.container';
import usersRoleSelectorContainer from './containers/usersRoleSelector.container';
import users from './components/users/users.component';
import usersActivities from './components/usersActivities/usersActivities.component';
import usersBrandAdminForm from './components/usersBrandAdminForm/usersBrandAdminForm.component';
import usersBrands from './components/usersBrands/usersBrands.component';
import usersEditForm from './components/usersEditForm/usersEditForm.component';
import usersRoleSelector from './components/usersRoleSelector/usersRoleSelector.component';
import routeProviderConfig from './configs/routeProvider.config';

const usersModule = angular.module('users', [])
.constant('USERS_EVENTS', USERS_EVENTS)
.component('usersContainer', usersContainer)
.component('usersActivitiesContainer', UsersActivitiesContainer)
.component('usersBrandAdminModalContainer', usersBrandAdminModalContainer)
.component('usersBrandsListContainer', usersBrandsListContainer)
.component('usersEditModalContainer', usersEditModalContainer)
.component('usersListContainer', usersListContainer)
.component('usersPermissionsModalContainer', usersPermissionsModalContainer)
.component('usersRevokeModalContainer', usersRevokeModalContainer)
.component('usersRoleSelectorContainer', usersRoleSelectorContainer)
.component('users', users)
.component('usersActivities', usersActivities)
.component('usersBrandAdminForm', usersBrandAdminForm)
.component('usersBrands', usersBrands)
.component('usersEditForm', usersEditForm)
.component('usersRoleSelector', usersRoleSelector)
.config(routeProviderConfig);


export default usersModule.name;
